module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-day-6b6cda86.svg";